// extracted by mini-css-extract-plugin
module.exports = {"root":"NoInvoiceResults_root__22vIM","content":"NoInvoiceResults_content__3jE0c","message":"NoInvoiceResults_message__1R2pD"};